module.exports = __webpack_public_path__ + "media/images/icons/icon-speak-747a1858ff7d32acf859e93b88609472.png";